module.exports = __webpack_public_path__ + "static/media/grey-pdf.8608f5e7.svg";